import React from "react";
import Tooltip from '@mui/material/Tooltip';
import { connect } from "react-redux";
import CurrencyFormatter from "currency-formatter";
import { DESCENDANT_ORDER, YEARLY } from "../../../../config";

function Item({ label, bold = false, percent = false, currentCompanyAltmanZScore }) {

  let array = currentCompanyAltmanZScore ?
    currentCompanyAltmanZScore[currentCompanyAltmanZScore?.prefix + label.replace(/[ ÷]/g, "")]
    ?.filter((value, index) => index >= (currentCompanyAltmanZScore?.prefix === YEARLY ? 0 : 11)) :
    [];
  if(currentCompanyAltmanZScore?.dateOrder == DESCENDANT_ORDER) array = array?.slice().reverse();
      //we must reverse the array if dateOrder is descendant order because data in Altman Z Score store is date ascendant

  return (
    <div 
      className={
        bold
          ? "flex items-center mt-5 pb-2 font-semibold"
          : "flex items-center mt-3"
        }
      >
      <div className="whitespace-nowrap flex items-center pt-2" style={{ minWidth: "22em" }} >
        {label}
      </div>
      <div className="flex pt-2">
        {array?.map((obj) => (
          <div className={obj.disabled? "disabled flex" : "flex"} style={{ minWidth: "10em" }}>
            <div style={{ minWidth: "0.5em" }} />
            <div className={obj.color} >
              {typeof obj.value === "string" ? obj.value : CurrencyFormatter.format(percent ? obj.value * 100 : obj.value, { code: "" })}
              {percent ? "%" : ""}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyAltmanZScore: state.financialRatios.currentCompanyAltmanZScore
});

export default connect(mapStateToProps)(Item);
